import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import MediaQuery from 'react-responsive'
import { formatPlainText } from 'utils/content-utils'
import { Header, HeaderImage, } from 'modules/common/components/ui/PageHeader'
import { PageArticle, PageHeader, PageContent, Row, ProCalendarWrap }  from 'modules/common/components/grid'
import { H1, H2, P, UL, HR, A, B, StyledLink }  from 'modules/common/components/elements'
import { StaticMap, MapLink } from 'modules/common/components/ui/StaticMap'
import Helmet from 'react-helmet'
import { getSeoForPage } from 'modules/seo'
import EventCard from 'modules/events/components/EventCard'
import ServiceCard from 'modules/events/components/ServiceCard'
import InlineLoader from 'modules/common/components/inlineloader'
import Button from 'modules/common/components/button/Button'

import ProCalendar from './ProCalendar'
import CourseDetails from './CourseDetails'
import './ProPage.css'

import { APP_THEME } from 'config'

class ProPage extends Component {
  
  componentWillMount() {
    this.loadData()
  }

  componentWillReceiveProps(nextProps){
    const {
      pro: {
        id: currentProId = undefined
      }
    } = this.props
    const {
      pro: {
        id: nextProId = undefined
      }
    } = nextProps
    const pro1 = parseInt(currentProId, 10)
    const pro2 = parseInt(nextProId, 10)
    if(pro1 !== pro2 && pro2 && !isNaN(pro2)){
      this.loadEvents(pro2)
    }
  }

  loadData() {
    const { id, loadPro, loadCourses } = this.props
    loadPro(id)
    loadCourses()
    if(!isNaN(id)){
      this.loadEvents(id)
    }
  }
  
  loadEvents(id){
    const { loadProEvents } = this.props
    loadProEvents(id)
  }

  scrollToProducts = (event) => {
    if (!this.products) return
    event.preventDefault()
    this.products.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  render() {
    const {
      pro,
      locale,
      localized,
      events = [],
      packages = [],
      courses = [],
      imageSrc,
      imageSrcDesktop,
      isFetching,
      hasEvents,
      hasPackages,
    } = this.props

    if (!pro || !pro.id) return <InlineLoader />

    const {
      first_name,
      last_name,
      title,
      picture,
      description,
      services,
      phone,
      website,
    } = pro

    const pictureSrc =
      picture instanceof Array && picture.length > 0
        ? picture[0].formatted_large
        : undefined
    
    const seoData = getSeoForPage("custom", {
      title: `${first_name} ${last_name}`,
      description: description,
      image: pictureSrc || imageSrc
    })
    
    const hasServices = Boolean(services && services.length && services[0].service_types && services[0].service_types.length)
    
    return (
      <div className="page page--pro full-height">
        <Helmet title={seoData.title} meta={seoData.meta} />
        <Header stripe>
          <MediaQuery maxWidth={767}>
            <HeaderImage noOverlay src={imageSrc} />
          </MediaQuery>
          <MediaQuery minWidth={768}>
            <HeaderImage noOverlay src={imageSrcDesktop} />
          </MediaQuery>
        </Header>
        <PageArticle>
          <Row>
            <PageHeader id="page-header">
                <figure className="figure-pro" style={{ backgroundImage: `url(${pictureSrc})` }}>
                  <img className="figure-pro--img" src={pictureSrc} alt={`${first_name} ${last_name}`} />
                </figure>
                <H1 className="title--main" halfMargin>
                  {`${first_name} ${last_name}`}
                </H1>
                <P textDark halfMarginTop noBottomMargin>
                  {title && <B block>{title}</B>}
                </P>
                <UL plain noTopMargin>
                  { courses && courses
                    .filter(item => item !== undefined)
                    .map(({id = undefined, name = ''}) => (id && <li key={`link-${id}`}><StyledLink to={`/courses/${id}`} textDark>{name}</StyledLink></li>))
                  }
                </UL>
                <P textDark halfMargin>
                  <Button
                    wide
                    onClick={this.scrollToProducts}
                  >
                    {localized("pro.cta_booking_link")}
                  </Button>
                </P>
                <HR className="stretch" />
                <P className="contact contact-pro">
                  { phone && <A textDark href={`tel:${phone}`} block noHover>{localized("pro.phone")} {phone}</A>}
                  { website && <A textDark href={website} block>{website}</A>}
                </P>
                { 
                  (courses && courses.length === 1) && courses.filter(item => item !== undefined).map(({id, geolocation, name, address}) => (
                  <div key={id} className="course-details pro--course-details hide-for-medium-only">
                    <div>
                      <div className="pro--course-details-item">
                        <StaticMap className="stretch" lang={locale} coordinates={geolocation} />
                        <MapLink lang={locale} coordinates={geolocation}>
                          {localized("course.label_map_link")}
                        </MapLink>
                        <HR
                          halfMarginTop
                          className="stretch"
                        />
                      </div>
                      <CourseDetails 
                        name={name}
                        address={address}
                        id={id}
                        txt={localized("pro.open_club_page")}
                      />
                    </div>
                  </div>)
                  )
                }
            </PageHeader>
            <PageContent id="page-content" className="content--page">
              <H2>{localized("pro.title_description")}</H2>
              <div
                dangerouslySetInnerHTML={{
                  __html: formatPlainText(description)
                }}
              />
              <HR className="stretch" noBottomMargin />
              <div className="product--wrap" ref={el => this.products = el}>
                <Tabs id="products">
                  <TabList className={
                    {
                      'react-tabs__tab-list': true,
                      'react-tabs__tab-list--incontent': true
                    }
                  }>
                    <Tab
                      disabled={isFetching || !hasPackages}
                      className={
                        {
                          'react-tabs__tab': true,
                          'react-tabs__tab--alternate': true,
                          [`react-tabs__tab--theme-${APP_THEME}`]: true,
                          'react-tabs__tab--loading': isFetching && !hasPackages,
                        }
                      }
                    >
                      {localized("pro.header.packages_button")}
                    </Tab>
                    <Tab
                      disabled={isFetching || !hasEvents}
                      className={
                        {
                          'react-tabs__tab': true,
                          'react-tabs__tab--alternate': true,
                          [`react-tabs__tab--theme-${APP_THEME}`]: true,
                          'react-tabs__tab--loading': isFetching && !hasEvents,
                        }
                      }
                    >
                    {localized("pro.header.courses_button")}
                  </Tab>
                  { hasServices && (
                    <Tab
                      className={
                        [
                          'react-tabs__tab': true,
                          'react-tabs__tab--alternate': true,
                          [`react-tabs__tab--theme-${APP_THEME}`]: true,
                        ]
                      }>
                    {localized("pro.header.services_button")}
                    </Tab>
                  )}
                  </TabList>
                  <TabPanel>
                    <Row id="package--list" eventList className="card-grid">
                      { 
                        (!isFetching && !hasPackages) ? <p className="no-results">{localized("pro.no_packages")}</p> : packages.map(event => <ServiceCard className="card-grid__item" key={event.id} event={event} />)
                      }
                    </Row>
                  </TabPanel>
                  <TabPanel>
                    <Row id="event--list" eventList className="card-grid">
                      {
                        (!isFetching && !hasEvents) ? <p className="no-results">{localized("pro.no_group_lessons")}</p> : events.map(event => <EventCard className="card-grid__item" key={event.id} event={event} />)
                      }
                    </Row>
                  </TabPanel>
                  { hasServices && (
                    <TabPanel>
                      <ProCalendarWrap id="private-calendar"><ProCalendar pro={pro} {...this.props} /></ProCalendarWrap>
                    </TabPanel>
                    )
                  }
                </Tabs>
              </div>
            </PageContent>
          </Row>
        </PageArticle>
      </div>
    )
  }
}

export default ProPage



// WEBPACK FOOTER //
// ./src/modules/pros/components/ProPage.js